import React from 'react';
import { Lock, ShieldCheck, BadgeCheck, Shield } from 'lucide-react';

const items = [
  {
    icon: Lock,
    title: 'Enkripsi Data Berlapis',
    desc: 'Semua data Anda dilindungi dengan enkripsi AES-256 bit. Keamanan data pribadi dan transaksi adalah prioritas utama kami.',
    color: '#0C8F86',
  },
  {
    icon: Shield,
    title: 'Kami Tidak Menjual Data Anda',
    desc: 'Privasi Anda adalah hak Anda. Tradiora tidak pernah menjual, menyewakan, atau membagikan data pribadi Anda ke pihak ketiga manapun.',
    color: '#58bd7d',
  },
  {
    icon: BadgeCheck,
    title: 'Sertifikasi & Kepatuhan',
    desc: 'Tradiora mematuhi standar keamanan internasional ISO 27001 dan regulasi perlindungan data pribadi yang berlaku di Indonesia.',
    color: '#8b5cf6',
  },
];

function SecuritySection() {
  return (
    <section className="security-section" style={{ padding: '100px 0', background: 'var(--bg)' }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="block-text center" style={{ marginBottom: 48 }}>
              <h3 className="heading">Keamanan & Privasi Anda</h3>
              <p className="fs-20" style={{ color: 'var(--text)', maxWidth: 560, margin: '12px auto 0' }}>
                Data Anda adalah prioritas kami. Kami berkomitmen melindungi privasi setiap pengguna Tradiora.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="col-xl-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay={index * 150}
                style={{ marginBottom: 24 }}
              >
                <div style={{
                  textAlign: 'center',
                  padding: '44px 28px',
                  borderRadius: 20,
                  background: 'var(--surface)',
                  border: '1px solid var(--line)',
                  height: '100%',
                  transition: 'all 0.3s ease',
                }}
                  className="security-card"
                >
                  <div style={{
                    width: 76, height: 76, borderRadius: '50%',
                    background: `${item.color}10`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 22px', border: `1px solid ${item.color}20`,
                  }}>
                    <Icon size={32} color={item.color} />
                  </div>
                  <h5 style={{
                    fontSize: 18, fontWeight: 700, color: 'var(--onsurface)',
                    marginBottom: 14,
                  }}>
                    {item.title}
                  </h5>
                  <p style={{ color: 'var(--text)', fontSize: 14, lineHeight: 1.75 }}>
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="row justify-content-center" style={{ marginTop: 48 }}>
          <div className="col-xl-8 col-lg-10">
            <div style={{
              background: 'linear-gradient(135deg, rgba(12,143,134,0.06), rgba(88,189,125,0.06))',
              borderRadius: 16,
              padding: '34px 44px',
              border: '1px solid rgba(12,143,134,0.1)',
              textAlign: 'center',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14, flexWrap: 'wrap',
            }}>
              <div style={{
                width: 44, height: 44, borderRadius: '50%',
                background: 'rgba(12,143,134,0.15)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>
                <ShieldCheck size={24} color="#0C8F86" />
              </div>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: 16, color: 'var(--onsurface)', fontWeight: 600, marginBottom: 6 }}>
                  Semua data Anda dilindungi dengan standar keamanan tertinggi
                </div>
                <p style={{ color: 'var(--text)', fontSize: 14 }}>
                  Tradiora menggunakan enkripsi end-to-end dan tidak menyimpan informasi sensitif tanpa izin Anda.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SecuritySection;
